import { Action } from 'redux';
import { StatementAuthStateStructure } from '../../angular-elements/shared/interfaces/statementAuthStateStructure.interface';

export class PayloadAction implements Action {
  type: string;
  statementAuthStateStructure?: StatementAuthStateStructure;
}

const INITIAL_STATE: StatementAuthStateStructure = {
  statementCheck: false
};

export const LOAD_STATEMENT_AUTH = 'LOAD_STATEMENT_AUTH';
export const INIT_PAYLOAD = 'INIT_PAYLOAD';
const RESET_STATE = 'RESET_STATE_StatementAuth';

export function loadStatementAuth(info: StatementAuthStateStructure): PayloadAction {
  return {
    type: LOAD_STATEMENT_AUTH,
    statementAuthStateStructure: info
  };
}

export function resetStatementAuth(): PayloadAction {
  return { type: RESET_STATE };
}

export function statementAuth( state: StatementAuthStateStructure = INITIAL_STATE, action: PayloadAction ) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case LOAD_STATEMENT_AUTH:
      copiedState.statementCheck = action.statementAuthStateStructure.statementCheck;
      return Object.assign({}, state, copiedState);
    case RESET_STATE:
      return INITIAL_STATE;
    case INIT_PAYLOAD:
    default:
      return state;
  }
}

